<div class="c-card main-content">
  <div class="p-none">
    <cbs-button-bar class="sticky-content"></cbs-button-bar>
    <cbs-search-filter></cbs-search-filter>
    <cbs-search-results></cbs-search-results>
  </div>
</div>
